import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-android-plain" />
          <Techstack iconName="devicon-java-plain" />
          <Techstack iconName="devicon-laravel-plain" />
          <Techstack iconName="devicon-php-plain" />
          <Techstack iconName="devicon-javascript-plain" />
          <Techstack iconName="devicon-mysql-plain" />
          <Techstack iconName="devicon-jquery-plain" />
          <Techstack iconName="devicon-css3-plain" />
          <Techstack iconName="devicon-git-plain-wordmark" />
          <Techstack iconName="devicon-firebase-plain" />
          <Techstack iconName="devicon-bootstrap-plain-wordmark" />
        </Row>
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Techstack iconName="devicon-microsoftsqlserver-plain" />
          <Techstack iconName="cib-visual-studio-code" />
          <Techstack iconName="devicon-npm-original-wordmark" />
          <Techstack iconName="cib-postman" />
          <Techstack iconName="devicon-apache-plain" />
          <Techstack iconName="cib-heroku" />
        </Row>
        {/* <Github /> */}
      </Container>
    </Container>
  );
}

export default About;
